import * as React from 'react';
import {
  ObservabilityProvider,
  useObservabilityConfig,
} from '@sail/observability';
import type {AnalyticsConfig} from '@sail/observability';
import {useAuthContext} from '../data-layer-client/AuthContext/AuthContext';

// TODO: this logic should be integrated inside ConnectSdkProvider, but it
// requires reading from a context that is below it in the tree (Auth).
/* eslint-disable camelcase */
export default function ConnectSdkProviderObservability({
  children,
}: {
  children: React.ReactNode;
}) {
  const observabilityConfig = useObservabilityConfig();
  const {authInfo} = useAuthContext();

  const analytics: AnalyticsConfig | undefined = React.useMemo(() => {
    if (!observabilityConfig) {
      return undefined;
    }

    if (!authInfo) {
      return observabilityConfig.analytics;
    }

    const parameters = {
      arb_id: authInfo.analyticsRbEventId,
      connected_account_id: authInfo.connectedAccountId,
      merchant_id: authInfo.connectedAccountId,
      platform_id: authInfo.platformId,
      livemode: authInfo.livemode,
      country: authInfo.merchantData?.country,
      hasMerchantData: !!authInfo.merchantData,
      hasExpressDashboardAccess:
        authInfo.merchantData?.hasExpressDashboardAccess,
      hasStandardDashboardAccess:
        authInfo.merchantData?.hasStandardDashboardAccess,
      isV2AccountSession: authInfo.isV2AccountSession,
      stripeOwnsLossLiability: authInfo.merchantData?.stripeOwnsLossLiability,
      stripeOwnsOnboarding: authInfo.merchantData?.stripeOwnsOnboarding,
      stripeOwnsPricing: authInfo.merchantData?.stripeOwnsPricing,
    };

    return {
      ...observabilityConfig.analytics,

      parameters: {
        ...observabilityConfig.analytics?.parameters,
        ...parameters,
      },
    };
  }, [observabilityConfig, authInfo]);

  if (!observabilityConfig?.project) {
    return <>{children}</>;
  }

  return (
    <ObservabilityProvider
      analytics={analytics}
      project={observabilityConfig?.project}
    >
      {children}
    </ObservabilityProvider>
  );
}
/* eslint-enable */
